import queryString from 'query-string';

// 内部の遷移から来たかどうか。docs.geolonia.com のユーザー登録リンクのように、
// 同じ会社のサイト同士をつなぐ導線には utm_medium=internal を付けている。
//
// Mixpanel は URL に utm_* があると、2か所に書く。
//
//   1. そのページロードのイベントのプロパティ（直前の流入元）
//   2. people の initial_utm_*（施策の初回接触。set_once なので先勝ち）
//
// 1 は内部の遷移でも正しいが、2 を内部の遷移で埋めてしまうと、gmail や
// x.com の施策で来た人の初回接触が docs に置き換わり、施策の効果を測れなく
// なる。内部の遷移のときだけ 2 を飛ばすために使う。

const isInternalReferral = (search: string = window.location.search): boolean => {
  const medium = queryString.parse(search).utm_medium;

  if (Array.isArray(medium)) {
    return medium[0] === 'internal';
  }

  return medium === 'internal';
};

export default isInternalReferral;
